import type { AppetitesResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetAppetitesQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetAppetitesDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

export const useGetAppetites = createQueryHook<
  Record<string, never>,
  AppetitesResponseRow[],
  GetAppetitesQuery
>({
  trpcQueryOptions: (trpc) =>
    trpc.frontend.appetite.getAppetites.queryOptions(),
  mapTrpcDataToGraphQL: (data) => ({
    appetite: data,
  }),
  graphqlDocument: GetAppetitesDocument,
});
